import { useContext } from 'react';
import { SaleContext } from '../SaleProvider/context';
import { SeoContext } from '../SeoProvider/context';

const useStores = (...args) => {
  const saleStore = useContext(SaleContext);
  const seoStore = useContext(SeoContext);

  const stores = {
    sale: saleStore,
    seo: seoStore,
  };

  return args.reduce((prev, storeKey) => {
    return { ...prev, [storeKey]: stores[storeKey] };
  }, {});
};
export default useStores;
